import {
	Component,
	inject,
	resource,
	signal,
	linkedSignal,
} from "@angular/core"
import { LogTable } from "@app/activity/log-table/log-table"
import { COMMON_IMPORTS } from "../common-imports"
import { ApiService } from "@app/services/api.service"
import { TableWrapComponent, SpinOrContent } from "@app/utils/utils.component"
import { BtnGroupV2 } from "@app/inputs-v2/btn-group"

@Component({
	selector: "app-activity",
	imports: [
		COMMON_IMPORTS,
		TableWrapComponent,
		LogTable,
		SpinOrContent,
		BtnGroupV2,
	],
	template: `
		<div class="p-2">
			<div class="row">
				<div class="col-12">
					<btn-group-v2
						title_ph_lang="activity_period"
						optionsListName="activity_periods"
						[(value)]="period"
					/>
					<button
						class="btn btn-icon"
						titleLang="expand"
						(click)="isAllOpened.update((v) => !v)"
						[icon]="isAllOpened() ? 'narrow' : 'expand'"
					></button>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<app-activity-log-table
						[isAllOpened]="isAllOpened()"
						[period]="period()"
					/>
				</div>
			</div>

			<div class="row">
				<div class="col-4">
					<app-spin-or-content [isSpin]="userNums.isLoading()">
						<app-table-wrap fieldsStr="status,count">
							@for (row of userNums.value(); track row) {
								<tr>
									@for (field of ["status", "co"]; track field) {
										<td>{{ row[field] }}</td>
									}
								</tr>
							}
						</app-table-wrap>
					</app-spin-or-content>
				</div>
			</div>
		</div>
	`,
})
export class Activity {
	apiService = inject(ApiService)
	userNums = resource({
		loader: () => this.apiService.post("get_user_type_to_num"),
	})
	period = signal("daily")
	isAllOpened = linkedSignal({
		source: this.period,
		computation: () => false,
	})
}
